import React from 'react';
import Box from "@mui/material/Box";
import {contentTexts} from "../ContentText";
import {HorizontalLineSecondary} from "../Components/HorizontalLine/HorizontalLinePrimary";
import "./CostComponent.css"
import {Button} from "@mui/material";
import PrimaryButton from "../Components/Buttons/PrimaryButton";
import {defaultColors} from "../ColorSchema";
import discount from "../../Images/rabatt.svg"
import TopTitle from "../Components/TopTitle";
import SubTitle from "../Components/SubTitle";

function CostComponent(props) {
    return (
        <Box className={"cost_content"}
             sx={{
                 flexDirection: {xs: 'column', md: 'row'},
                 display: "flex",
                 justifyContent:"center",
                 alignItems: "center",
             }}
             ref={props.refs}>

            <Box className={"cost_new_customer_container text_cost_container "}  sx={{width:{xs:"100%", md:"50%"}}}>
                <TopTitle sx={{color: defaultColors.surface_container_highest}}>{contentTexts.costPageTitle}</TopTitle>
                <SubTitle sx={{color: defaultColors.surface_container_highest}}>{contentTexts.costPageSubtitle}</SubTitle>
                <HorizontalLineSecondary className={"font_margin"}/>
                {contentTexts.contentTextCostPage.map((value, index) => (
                    <p key={index} className={"content_font_appointment"}>{value}</p>))}
            </Box>
            <Box className={"cost_new_customer_container flexColumnCenter"} sx={{width:{xs:"100%", md:"50%"}}}>
                <Box className={"cost_boundingbox"}>
                    <Box className={"cost_offer_container flexColumnCenter"}>
                        <img src={discount} style={{width: "40px"}} alt={"Discount Icon"}/>
                        <p style={{
                            fontSize: "24px",
                            lineHeight: "32px",
                            color: defaultColors.on_surface,
                            margin: "0px"
                        }}>Neukundenrabatt</p>
                        <p style={{
                            fontSize: "16px",
                            lineHeight: "24px",
                            letterSpacing: "0.5px",
                            color: defaultColors.on_surface_variant,
                            margin: "0px"

                        }}>{contentTexts.costTextCostPage}</p>

                        <p
                            style={{
                                margin: "0px"
                            }}><span style={{
                            fontSize: "55px",
                            lineHeight: "64px",
                            letterSpacing: "-0.25px",
                            color: defaultColors.error
                        }}> {contentTexts.costNewCustomer} </span> <span style={{
                            fontSize: "16px",
                            lineHeight: "24px",
                            letterSpacing: "0.5px",
                            color: defaultColors.on_surface_variant
                        }}>/ Monat</span></p>
                        <p style={{
                            fontSize: "24px",
                            lineHeight: "32px",
                            color: defaultColors.on_surface_variant,
                            marginTop: "0px",
                            paddingLeft: "125px",
                            margin: "-20px 0px 0px 0px"
                        }}>statt {contentTexts.costNewCustomerReal}</p>
                        <PrimaryButton style={{
                            margin: "0px"
                        }} className={"cost_button"}
                                       onClick={() => (props.talk_ref.current?.scrollIntoView({behavior: 'smooth'}))}
                        >Jetzt Termin vereinbaren</PrimaryButton>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default CostComponent;